import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/services/api.service';
import { PopupService } from 'src/app/services/popup.service';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
  @ViewChild('content') 
  private elTitle : any; 
  obj:any

  constructor(private modalService: NgbModal,public apiService:ApiService,public popupService:PopupService) {}
  ngOnInit(): void {

    this.apiService.emitRespons.subscribe(i=>{
      this.obj = i
      console.log(i);
      
      this.modalService.open(this.elTitle, {ariaLabelledBy: 'modal-basic-title',windowClass: 'custom-class'}).result.then((result) => {
        this.popupService.clickButn.next(result);
      }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    })
  }
}
